<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,23.999c-0.207,0-0.406-0.087-0.548-0.238c-0.017-0.017-2.491-2.398-10.212-2.494C0.564,21.261,0.007,20.703,0,20.025
		V4.249c0-0.334,0.137-0.659,0.375-0.892c0.242-0.232,0.557-0.358,0.89-0.358c5.718,0.073,8.778,1.302,10.258,2.199
		c0.314-1.001,0.852-1.914,1.572-2.664c1.059-1.176,2.436-2.036,3.976-2.479C17.191,0.019,17.321,0,17.452,0
		c0.255,0,0.503,0.072,0.719,0.208c0.353,0.218,0.57,0.6,0.579,1.02v2.053c1.337-0.178,2.673-0.273,3.977-0.281c0,0,0,0,0,0
		c0.342,0,0.654,0.125,0.89,0.353C23.859,3.587,23.998,3.912,24,4.245v15.772c-0.007,0.684-0.564,1.243-1.243,1.25
		c-7.724,0.096-10.193,2.478-10.217,2.502l-0.031,0.03C12.373,23.927,12.191,23.999,12,23.999z M1.5,19.771
		c5.263,0.097,8.233,1.194,9.75,2.037V6.826C10.53,6.28,7.833,4.625,1.5,4.503V19.771z M18.75,16.845
		c0,0.354-0.251,0.663-0.598,0.734c-1.531,0.317-2.903,1.091-3.967,2.238c-0.51,0.531-0.898,1.156-1.15,1.838
		c1.58-0.81,4.502-1.794,9.464-1.885V4.502c-1.236,0.019-2.495,0.117-3.75,0.292V16.845z M12.75,19.179
		c0.11-0.135,0.225-0.266,0.345-0.39c1.126-1.215,2.559-2.088,4.155-2.533V1.569c-1.179,0.385-2.23,1.068-3.057,1.986
		c-0.79,0.823-1.299,1.884-1.443,2.997V19.179z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'book-flip-page',
    },
    name: {
      type: String,
      required: false,
      default: 'BookFlipPage',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>